import React from "react"
import { Modal, ModalBody } from "@silversea-ssc/ui-components-react"
import { t, Trans } from "@lingui/macro"
import useModal from "../ModalProvider/useModal"
import SidebarHeader from "../Sidebar/SidebarHeader/SidebarHeader"
import PriceSummary from "../Sidebar/PriceSummary/PriceSummary"
import Receipt from "../Receipt/Receipt"
import { FetchPageContent } from "../../app-core/_common/sanity/fetch-page-content"
import { WebQuoteExitIntent } from "../../app-core/features/_common/web-quote-exit-intent"
import styles from "./ReceiptModal.module.scss"

type ReceiptModalProps = {
    sanityContent: FetchPageContent
    webQuoteExitIntent: WebQuoteExitIntent
}

const ReceiptModal: React.FC<ReceiptModalProps> = ({ sanityContent, webQuoteExitIntent }) => {
    const { closeModal } = useModal()

    return (
        <Modal
            title={t`Price Details`}
            size="fullscreen"
            modal={{ isOpen: true, onRequestClose: () => closeModal("closeWithCallback") }}
            dataContentName="sidebar-modal"
        >
            <ModalBody variant="full" paddingTop={false}>
                <div className={styles.wrapper}>
                    <SidebarHeader
                        sanityContent={sanityContent}
                        headerContentClassName={styles.headerContent}
                        webQuoteExitIntent={webQuoteExitIntent}
                    />
                    <div className={styles.content}>
                        <PriceSummary />
                    </div>
                    <hr className={styles.separator} />
                    <div className={styles.content}>
                        <div className={styles.detailsTitle}>
                            <Trans>Details</Trans>
                        </div>
                        <Receipt withInclusions />
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default ReceiptModal
